import { atom } from 'recoil';
import type { NotificationInfoResponse } from '@/types/api/mypage/notifications';

/**
 * お知らせ情報取得APIの結果を保持する state。
 * ログイン後トップや通知一覧で共通利用するため、取得済み一覧を単一 state にまとめる。
 */
const NotificationInfoState = atom<NotificationInfoResponse>({
  key: 'NotificationInfoState',
  default: {
    notifications: [],
  },
});
export default NotificationInfoState;
